// Angular
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpContextToken, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

// Context
export const BYPASS = new HttpContextToken<boolean>(() => false);
export const CIP = new HttpContextToken<boolean>(() => true);

// RxJS
import { Observable } from 'rxjs';

// Services
import { AuthenticationService } from 'app/auth/service/authentication.service';
import * as CenterService from 'app/center/service/index';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(private _authenticationService: AuthenticationService, private _centerService: CenterService.Center) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Bypass (Without adding authenticity headers or the CIP parameter)
    if (request.context.get(BYPASS)) {
      return next.handle(request);
    }

    let newRequest = request.clone({
      headers: new HttpHeaders({...this._authenticationService.authHeaders}),
    });

    // Add authenticity headers without adding the CIP parameter
    if (!newRequest.context.get(CIP)) {
      return next.handle(newRequest);
    } else {
      newRequest = newRequest.clone({
        params: newRequest.params.append('CIP', this._centerService.currentCIP)
      });
      return next.handle(newRequest);
    }
  }
}
